<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>

    <!--    弹出告警信息-->

    <alarm-information :visible="videoLinkage"
                       :videoType="videoType"
                       :latestAlarmInformation="latestAlarmInformation"
                       @alarmInformationVisible="dialog(data)"></alarm-information>
    <alarm-handling :alarmId="alarmId"
                    :code="code"
                    :title="title"
                    :visible="alarmVisible"
                    @dialogClose="(data) => this.alarmVisible = data"
                    @getData="() =>{
                      this.notify.close();
                      this.getAlarmData()
                    }"></alarm-handling>
    <!--    修改密码-->
    <change-password :text="text" :dialogVisible="dialogVisible" @closeChangePassword="closeChangePassword"
                     :showClose="false"></change-password>

  </div>
</template>

<script type="text/javascript">
import '@/assets/css/global.css'
import '@/assets/css/custom.css'
import {getAlarmByCommitTimeAsc} from "@/network/alarm-realtime";
import AlarmInformation from "@/components/AlarmInformation";
import {getSystematicByCodes} from "@/network/systematic";
import {isEnableByDeviceId} from "@/network/device-linkage";
import {getAccountInfo, validationPwSecurity} from "@/network/account";
import { getCookie, playRead, setCookie} from "@/utils/common";
import {initPlaten} from "@/assets/js/components/InitPlaten";
import AlarmHandling from "@/views/alarm/AlarmHandling";
import ChangePassword from "@/components/component/ChangePassword";
import {getPermission} from "@/network/resource";

export default {
  name: 'App',
  components: {ChangePassword, AlarmInformation, AlarmHandling},
  provide() {
    return {
      reload: this.reload,
      overflow: this.overflow,
    }
  },
  mounted() {
    initPlaten(); //初始化大屏
    setTimeout(() => {
      this.validationPwSecurity();
    }, 500);
    this.getAlarmData();
    this.alarmRealTimePopup();
    this.getPermission();
    
    // 监听用户交互，用于启用语音播报权限
    this.initVoicePermission();
  },
  created() {
    window.pageClick = this.pageClick;
    window.close = this.close;
    window.alarmHandling = this.alarmHandling;
    window.alarmElimination = this.alarmElimination;
    // 将当前实例暴露到 window，用于语音播报状态管理
    window.app = this;
    this.$store.dispatch('addIntervalObj', {'alarmRealTimePopup:5000': this.alarmRealTimePopup})
    this.$store.dispatch('addIntervalObj', {'getAlarmNotify:15000': this.getAlarmData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'alarmRealTimePopup')
    this.$store.dispatch('removeIntervalObj', 'getAlarmNotify')
  },
  data() {
    return {
      videoType: 'app',
      notify: null,
      alarmList: [],
      currentAlarm: 0,
      leftIcon: require('@/assets/images/icon/left.png'),
      rightIcon: require('@/assets/images/icon/right.png'),
      isRouterAlive: true,
      videoLinkage: false,
      videoPopUpTime: new Date(),
      latestAlarmInformation: {},
      oldUrl: window.location.hash, //获取当前页面url#号后面的路径
      newUrl: '',
      userMouth: null,
      alarmVisible: false,
      alarmId: null,
      title: '',
      code: '',
      text: '',
      dialogVisible: false,
      // 语音播报状态
      isVoicePlaying: false, // 是否正在播放语音
      hasUserInteracted: false, // 用户是否已交互，用于语音权限
    };
  },
  methods: {
    overflow() {
      // $('#app,.overflow').niceScroll({
      //   cursorcolor: "#043558",
      //   cursorwidth: "5px",
      //   cursorborderradius: "10px", // 滚动条圆角（像素）
      //   cursorborder: "1px solid #011427", // CSS方式定义滚动条边框
      //   /**
      //    true  无滚动时隐藏
      //    "cursor"  隐藏
      //    false 不隐藏,
      //    "leave" 仅在指针离开内容时隐藏
      //    "hidden" 一直隐藏
      //    "scroll" 仅在滚动时显示
      //    **/
      //   autohidemode: "leave", // 隐藏滚动条的方式
      // })
      // console.log(nicescroll);
    },
    //告警处理
    alarmHandling() {
      this.alarmVisible = true;
      this.code = "1";
      this.title = "告警处理";
      this.diaWidth = "60%";
      this.diaHeight = "30vh";
      this.alarmId = this.alarmList[this.currentAlarm].id;
    },
    //消警
    alarmElimination() {
      this.alarmVisible = true;
      this.code = "2";
      this.title = "消警";
      this.diaWidth = "60%";
      this.diaHeight = "30vh";
      this.alarmId = this.alarmList[this.currentAlarm].id;
    },
    getAlarmData() {
      getAlarmByCommitTimeAsc().then(res => {
        this.alarmList = res.data ? res.data : [];
        if (!this.notify && this.alarmList.length > 0) {
          //告警通知
          this.alarmNotify();
        }
        //获取最新的告警
        this.latestAlarmInformation = res.data ? res.data[0] : [];
        this.isEnableByDeviceId();

        //语言播报
        this.voiceNotificationOn(res.data);
      })
    },
    //判断该设备是否有启动的联动视频
    isEnableByDeviceId() {
      if (!this.latestAlarmInformation.deviceId) {
        return;
      }
      isEnableByDeviceId(this.latestAlarmInformation.deviceId).then(res => {
        if (res.code === 0) {
          if (!getCookie("videoPopUpTime")) {
            setCookie("videoPopUpTime", new Date().getTime(), null);
          }
          var currentTime = new Date();
          var tenMinutesAgo = currentTime.getTime() - 10 * 60 * 1000;
          if (getCookie("videoPopUpTime") < tenMinutesAgo) {
            this.videoLinkage = res.data;
            // console.log("最新告警信息：",this.latestAlarmInformation,this.videoLinkage);
          }
        }
      });
    },

    //大屏可视化页面实时告警弹窗不显示
    alarmRealTimePopup() {
      var url = window.location.hash; //获取当前页面url#号后面的路径
      // console.log("当前页面地址：", url);
      if (url.indexOf('#/platen') !== -1 && this.notify) {
        this.notify.close();
      }
    },
    //校验密码是否过期
    validationPwSecurity() {
      validationPwSecurity().then(res => {
        this.userMouth = res.data.forcedPasswordChangeTime;
        //修改密码
        if (res.code === 4) {
          this.dialogVisible = true;
          this.text = "系统检测到当前密码使用已超过" + this.userMouth + "个月,为了账号安全,请更换密码"
        }
      });
    },
    // 校验是否为第一次登陆
    getAccountInfo() {
      getAccountInfo().then(res => {
        this.account = res.data.account
      })
    },
    // 关闭修改密码弹窗
    closeChangePassword() {
      this.dialogVisible = false;
    },
    //获取声音告警通知是否开启
    voiceNotificationOn(languageBroadcast) {
      getSystematicByCodes(["voiceWarningNotification"]).then(res => {
        if (res.code === 0) {
          if (res.data[0].code === "voiceWarningNotification" && getCookie("audioAlarm") === "true") {
            if (res.data[0].val1 === 'true') {
              setCookie("audioAlarm", true, null);
              // 只有在没有语音正在播放时才播报新告警，避免中断正在播放的语音
              if (!this.isVoicePlaying) {
                this.speak(languageBroadcast);
              }
            } else {
              setCookie("audioAlarm", false, null);
            }
          }
        }
      })
    },

    // 初始化语音权限
    initVoicePermission() {
      const handleFirstInteraction = () => {
        if (!this.hasUserInteracted) {
          this.hasUserInteracted = true;
          // 播放一个静音的语音来激活权限
          try {
            const utterance = new SpeechSynthesisUtterance('');
            utterance.volume = 0;
            speechSynthesis.speak(utterance);
          } catch (e) {
            console.log('语音初始化失败:', e);
          }
          
          // 移除监听器
          document.removeEventListener('click', handleFirstInteraction);
          document.removeEventListener('touchstart', handleFirstInteraction);
          document.removeEventListener('keydown', handleFirstInteraction);
          
          // 【关键修复】如果用户之前开启了声音播报，首次交互后立即触发播报
          if (getCookie("audioAlarm") === "true") {
            setTimeout(() => {
              this.getAlarmData(); // 重新获取告警数据并触发播报
            }, 100);
          }
        }
      };
      
      // 监听各种用户交互事件
      document.addEventListener('click', handleFirstInteraction);
      document.addEventListener('touchstart', handleFirstInteraction);
      document.addEventListener('keydown', handleFirstInteraction);
    },

    speak: function (languageBroadcast) {
      // console.log("语音播报：", languageBroadcast);
      if (languageBroadcast != null && languageBroadcast.length > 0 && !this.isVoicePlaying) {
        // 如果用户还没有交互过，则静默等待，不播报（避免浏览器限制）
        if (!this.hasUserInteracted) {
          return; // 直接返回，不播报
        }
        
        this.isVoicePlaying = true;
        
        // 播报所有告警
        languageBroadcast.forEach((alarm, index) => {
          setTimeout(() => {
            playRead(alarm.msg);
          }, index * 100); // 每个告警间隔100ms
        });
        
        // 估算播放时间后重置状态
        const estimatedDuration = languageBroadcast.length * 5000; // 每个告警估算5秒
        setTimeout(() => {
          this.isVoicePlaying = false;
        }, estimatedDuration);
      }
    },

    //关闭视频联动页面
    dialog(data) {
      this.videoLinkage = data
      setCookie("videoPopUpTime", new Date().getTime(), null);
    },

    //告警通知分页
    pageClick(param) {
      if (this.currentAlarm === 0 && param === 'pre') {
        this.currentAlarm = this.alarmList.length - 1;
      } else if (this.currentAlarm === this.alarmList.length - 1 && param === 'next') {
        this.currentAlarm = 0;
      } else {
        if (param === 'pre') {
          this.currentAlarm = this.currentAlarm - 1;
        } else {
          this.currentAlarm = this.currentAlarm + 1;
        }
      }
      // eslint-disable-next-line no-debugger
      debugger
      document.getElementById('alarmName').innerText = "【"+this.alarmList[this.currentAlarm].deviceName + (this.alarmList[this.currentAlarm].pointName ? " " + this.alarmList[this.currentAlarm].pointName : "")+"】"
      document.getElementById('alarmDesc').innerText = this.alarmList[this.currentAlarm].msg
      document.getElementById('handle').innerText = this.alarmList[this.currentAlarm].isConfirm ? '' : '处理'
      document.getElementById('alarmLevel').innerText = this.alarmList[this.currentAlarm].levelName
      document.getElementById('alarmTime').innerText = this.alarmList[this.currentAlarm].createTime
      document.getElementById('alarmLevel').style.color = this.alarmList[this.currentAlarm].levelColor
    },
    //告警通知显示
    alarmNotify() {
      this.notify = null;
      const that = this;
      this.notify = this.$notify({
        title: '',
        dangerouslyUseHTMLString: true,
        message: `<div style="color: rgba(7, 230, 248, 1);font-size: 1.2rem;font-weight: bold;">实时告警</div>
<div style="margin-top: 20px;">
<span style="font-weight: bold;font-size: 1.1rem" id="alarmName">【${this.alarmList[this.currentAlarm].deviceName}${this.alarmList[this.currentAlarm].pointName ? " " + this.alarmList[this.currentAlarm].pointName : ""}】:</span>
<span style="color: #ccc;" id="alarmDesc">${this.alarmList[this.currentAlarm].msg}</span></div>
            <div style="margin-top: 10px"><span style="color: ${this.alarmList[this.currentAlarm].levelColor}"  id="alarmLevel">${this.alarmList[this.currentAlarm].levelName}</span>
            <span style="float: right;color: #999;" id="alarmTime">${this.alarmList[this.currentAlarm].createTime}</span></div>
            <div style="margin-top:20px;">
            <img style="cursor: pointer;" src=${this.leftIcon} onclick="pageClick('pre')" />
            <img style="margin-left: 10px;cursor: pointer;" src=${this.rightIcon} onclick="pageClick('next')" />
            <span style="float: right;" class="text-blue pointer"><a id="handle" onclick="alarmHandling()"
style="text-decoration-line: underline;">${this.alarmList[this.currentAlarm].isConfirm ? '' : '处理'}</a>
<a style="margin-left: 10px;text-decoration-line: underline" onclick="alarmElimination()">消警</a></span>
            </div>`,
        position: 'bottom-right',
        duration: 0,
        onClose: function () {
          that.close();
        }
      });
      this.alarmRealTimePopup();
    },
    close() {
      this.notify = null;
    },
    reload() {
      this.isRouterAlive = false
      const _this = this
      this.$nextTick(function () {
        _this.isRouterAlive = true
      })
    },
    // 查询当前用户的权限码
    getPermission() {
      getPermission().then(res => {
        if (res.code === 0) {
          localStorage.setItem("accountTypePermission", res.data.accountType) // 用户类型(比如：1，管理员；2，普通用户；)
          localStorage.setItem("permissionCodeList", JSON.stringify(res.data.permissionCodeList)) // 用户的权限码
        }
      })
    }
  }
}
</script>

<style>
.el-form-item__error {
  padding-top: 0;
  top: 85%;
}

.passwordCheck {
  padding: 3px 16px;
  background-color: rgba(41, 155, 255, .2);
  margin: 0 4px;
}

.passwordCheck.red {
  background-color: rgba(232, 86, 86, 1);
}

.name.red {
  color: rgba(232, 86, 86, 1);
}

.passwordCheck.brown {
  background-color: rgba(242, 169, 43, 1);
}

.name.brown {
  color: rgba(242, 169, 43, 1);
}

.passwordCheck.green {
  background-color: rgba(21, 222, 181, 1);
}

.name.green {
  color: rgba(21, 222, 181, 1);
}

body {
  margin: 0;
  padding: 0;
  border: 0;

  /*--------------火狐浏览器滚动条美化*/
  /*overflow-y: scroll;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;*/
}


/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: #011427;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #03162A;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
  background-color: #043558;
}

.input-width {
  width: 40%;
}

@media (max-width: 600px) {
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color: #011427;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #03162A;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    background-color: #043558;
  }

  .input-width {
    width: 85%;
  }

  .passwordCheck {
    padding: 3px 12px;
    margin: 0 2px;
  }
}
</style>
<!-- antVx6-->
<style lang="less">
@import 'assets/css/iconfont.css';
@import 'assets/css/index.less';
</style>
